import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=c3fe43a2&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fe43a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3fe43a2')) {
      api.createRecord('c3fe43a2', component.options)
    } else {
      api.reload('c3fe43a2', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=c3fe43a2&scoped=true&", function () {
      api.rerender('c3fe43a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bS5Yfld3f82Y/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports